import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "certificate",
  "use": "certificate-usage",
  "viewBox": "0 0 28.2 22.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.2 22.6\" id=\"certificate\"><path d=\"M21.8 22.6l-7.7-4.7-7.7 4.7V1.1H0V0h28.2v1.1h-6.4v21.5zM7.5 1.1v19.4l6.6-4 6.6 4V1.1H7.5zm9.9 13.4l-3.3-1.7-3.3 1.7.6-3.7-2.7-2.7 3.7-.6 1.7-3.3 1.7 3.3 3.7.6-2.6 2.6.5 3.8zm-3.3-3l1.9 1-.3-2.1 1.5-1.5-2.2-.3-1-1.9-1 1.9-2.1.3 1.5 1.5-.3 2.1 2-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol